import { FetchState } from 'src/reducers/fetchReducer';
import { getDashboard, DashboardResponse } from 'src/api/dashboardTotalWorkUnits';
import DashboardTotalWorkUnits from 'src/types/DashboardTotalWorkUnits';
import useFetchReducer from 'src/hooks/useFetchReducer';

const useTotalWorkUnitsFetch = (runId: string): [FetchState<DashboardTotalWorkUnits>] => {
  const fetchDashboardData = async (): Promise<DashboardResponse> => {
    if (!runId) {
      throw new Error('Invalid runId');
    }

    try {
      const response: DashboardResponse = await getDashboard(runId);
      if (response) {
        return response;
      } else {
        throw new Error('No data available');
      }
    } catch (error) {
      throw error;
    }
  };

  const [state] = useFetchReducer(fetchDashboardData, [runId]);

  return [state as FetchState<DashboardTotalWorkUnits>];
};

export default useTotalWorkUnitsFetch;
